var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("router-view", {
    scopedSlots: _vm._u([
      {
        key: "menuTitle",
        fn: function() {
          return [
            _c("div", { staticClass: "title" }, [
              _c("h2", [_vm._v(_vm._s(_vm.$t(_vm.menuTitle)))])
            ])
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }